'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M12 16.5l4-4h-3v-9h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V5.49h6V3.5H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2z' });

var SystemUpdateAlt = function SystemUpdateAlt(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

SystemUpdateAlt = (0, _pure2.default)(SystemUpdateAlt);
SystemUpdateAlt.muiName = 'SvgIcon';

exports.default = SystemUpdateAlt;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/SystemUpdateAlt.js
// module id = 2920
// module chunks = 0